export const manifest = (() => {
function __memo(fn) {
	let value;
	return () => value ??= (value = fn());
}

return {
	appDir: "_app",
	appPath: "_app",
	assets: new Set(["favicon.png","images/games/pairs/cards/car1.jpg","images/games/pairs/cards/car2.jpg","images/games/pairs/cards/car3.jpg","images/games/pairs/cards/car4.jpg","images/games/pairs/cards/car5.jpg","images/games/pairs/cards/car6.jpg","images/games/pairs/cards/car7.jpg","images/games/pairs/cards/car8.jpg","images/games/pairs/cover.png","images/games/puzzle/cover.png","images/games/puzzle/puzzle1.jpg","images/games/puzzle/puzzle2.jpg","images/games/puzzle/puzzle3.jpg","images/games/puzzle/puzzle4.jpg","images/games/puzzle/puzzle5.jpg","images/games/puzzle/puzzle6.jpg","images/games/puzzle/puzzle7.jpg","images/games/puzzle/puzzle8.jpg","images/games/race/car.png","images/games/race/cover.png","images/games/trivia/cover.png","images/logos/brands/audi.png","images/logos/brands/awdawd.png","images/logos/brands/seat.png","images/logos/brands/skoda.png","images/logos/brands/st.png","images/logos/brands/test.png","images/logos/brands/vw.png","images/logos/porsche-logo.png"]),
	mimeTypes: {".png":"image/png",".jpg":"image/jpeg"},
	_: {
		client: {"start":"_app/immutable/entry/start.oWl_Ef7M.js","app":"_app/immutable/entry/app.BSsPxUb0.js","imports":["_app/immutable/entry/start.oWl_Ef7M.js","_app/immutable/chunks/entry.DlJUL6IE.js","_app/immutable/chunks/index-client.7IhS7CEJ.js","_app/immutable/chunks/index.xUn_SZbm.js","_app/immutable/entry/app.BSsPxUb0.js","_app/immutable/chunks/index-client.7IhS7CEJ.js","_app/immutable/chunks/render.CrlMBPJT.js","_app/immutable/chunks/disclose-version.Dr32KdXi.js","_app/immutable/chunks/props.ey59GOCo.js"],"stylesheets":[],"fonts":[],"uses_env_dynamic_public":false},
		nodes: [
			__memo(() => import('./nodes/0.js')),
			__memo(() => import('./nodes/1.js')),
			__memo(() => import('./nodes/2.js')),
			__memo(() => import('./nodes/3.js')),
			__memo(() => import('./nodes/4.js')),
			__memo(() => import('./nodes/5.js')),
			__memo(() => import('./nodes/6.js')),
			__memo(() => import('./nodes/7.js')),
			__memo(() => import('./nodes/8.js')),
			__memo(() => import('./nodes/9.js')),
			__memo(() => import('./nodes/10.js')),
			__memo(() => import('./nodes/11.js')),
			__memo(() => import('./nodes/12.js')),
			__memo(() => import('./nodes/13.js')),
			__memo(() => import('./nodes/14.js')),
			__memo(() => import('./nodes/15.js'))
		],
		routes: [
			{
				id: "/",
				pattern: /^\/$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 4 },
				endpoint: null
			},
			{
				id: "/admin",
				pattern: /^\/admin\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 5 },
				endpoint: null
			},
			{
				id: "/admin/feedback",
				pattern: /^\/admin\/feedback\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 6 },
				endpoint: null
			},
			{
				id: "/admin/form-editor",
				pattern: /^\/admin\/form-editor\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 7 },
				endpoint: null
			},
			{
				id: "/admin/login",
				pattern: /^\/admin\/login\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 8 },
				endpoint: null
			},
			{
				id: "/admin/users",
				pattern: /^\/admin\/users\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 9 },
				endpoint: null
			},
			{
				id: "/api/admins",
				pattern: /^\/api\/admins\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/admins/_server.js'))
			},
			{
				id: "/api/admins/login",
				pattern: /^\/api\/admins\/login\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/admins/login/_server.js'))
			},
			{
				id: "/api/admins/[id]",
				pattern: /^\/api\/admins\/([^/]+?)\/?$/,
				params: [{"name":"id","optional":false,"rest":false,"chained":false}],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/admins/_id_/_server.js'))
			},
			{
				id: "/api/brands",
				pattern: /^\/api\/brands\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/brands/_server.js'))
			},
			{
				id: "/api/brands/[id]",
				pattern: /^\/api\/brands\/([^/]+?)\/?$/,
				params: [{"name":"id","optional":false,"rest":false,"chained":false}],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/brands/_id_/_server.js'))
			},
			{
				id: "/api/clients",
				pattern: /^\/api\/clients\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/clients/_server.js'))
			},
			{
				id: "/api/clients/login",
				pattern: /^\/api\/clients\/login\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/clients/login/_server.js'))
			},
			{
				id: "/api/clients/[id]",
				pattern: /^\/api\/clients\/([^/]+?)\/?$/,
				params: [{"name":"id","optional":false,"rest":false,"chained":false}],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/clients/_id_/_server.js'))
			},
			{
				id: "/api/forms",
				pattern: /^\/api\/forms\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/forms/_server.js'))
			},
			{
				id: "/api/forms/[department]",
				pattern: /^\/api\/forms\/([^/]+?)\/?$/,
				params: [{"name":"department","optional":false,"rest":false,"chained":false}],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/forms/_department_/_server.js'))
			},
			{
				id: "/api/questions",
				pattern: /^\/api\/questions\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/questions/_server.js'))
			},
			{
				id: "/api/questions/reorder",
				pattern: /^\/api\/questions\/reorder\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/questions/reorder/_server.js'))
			},
			{
				id: "/api/questions/[id]",
				pattern: /^\/api\/questions\/([^/]+?)\/?$/,
				params: [{"name":"id","optional":false,"rest":false,"chained":false}],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/questions/_id_/_server.js'))
			},
			{
				id: "/api/responses",
				pattern: /^\/api\/responses\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/responses/_server.js'))
			},
			{
				id: "/api/responses/[id]",
				pattern: /^\/api\/responses\/([^/]+?)\/?$/,
				params: [{"name":"id","optional":false,"rest":false,"chained":false}],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/responses/_id_/_server.js'))
			},
			{
				id: "/api/upload-image",
				pattern: /^\/api\/upload-image\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/upload-image/_server.js'))
			},
			{
				id: "/games/pairs",
				pattern: /^\/games\/pairs\/?$/,
				params: [],
				page: { layouts: [0,3,], errors: [1,,], leaf: 10 },
				endpoint: null
			},
			{
				id: "/games/puzzle",
				pattern: /^\/games\/puzzle\/?$/,
				params: [],
				page: { layouts: [0,3,], errors: [1,,], leaf: 11 },
				endpoint: null
			},
			{
				id: "/games/race",
				pattern: /^\/games\/race\/?$/,
				params: [],
				page: { layouts: [0,3,], errors: [1,,], leaf: 12 },
				endpoint: null
			},
			{
				id: "/games/trivia",
				pattern: /^\/games\/trivia\/?$/,
				params: [],
				page: { layouts: [0,3,], errors: [1,,], leaf: 13 },
				endpoint: null
			},
			{
				id: "/leaderboard",
				pattern: /^\/leaderboard\/?$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 14 },
				endpoint: null
			},
			{
				id: "/login",
				pattern: /^\/login\/?$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 15 },
				endpoint: null
			}
		],
		matchers: async () => {
			
			return {  };
		},
		server_assets: {}
	}
}
})();

export const prerendered = new Set([]);

export const base = "";